import {
  Autocomplete,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import "./style.css";
import { useDispatch } from "react-redux";
import { AutoComplete } from "rsuite";
import OptionsForRangeAndValues from "./OptionsForRangeAndValues";

const ValuesAndRangesComponent = ({
  rangePairs,
  values,
  setRangePairs,
  setValues,
}) => {
  const dispatch = useDispatch();
  // range

  const [startValue, setStartValue] = useState("");
  const [endValue, setEndValue] = useState("");

  const handleStartChange = (event) => {
    setStartValue(event.target.value);
  };

  const handleEndChange = (event) => {
    setEndValue(event.target.value);
  };

  const handleAddRange = () => {
    if (!startValue || !endValue) {
      alert("Please enter both start and end values.");
      return;
    }
    const start = parseFloat(startValue.trim());
    const end = parseFloat(endValue.trim());
    if (isNaN(start) || isNaN(end)) {
      alert("Please enter valid numeric values for start and end.");
      return;
    }
    dispatch(setRangePairs([...rangePairs, [start, end]]));
    setStartValue("");
    setEndValue("");
  };

  //   multiple selection

  const [inputValue, setInputValue] = useState("");

  const handleInputChangeMultiple = (event) => {
    setInputValue(event.target.value);
  };

  const handleAddValue = () => {
    if (inputValue.trim() !== "") {
      console.log("----------input------------")
      console.log(inputValue)
      dispatch(setValues([...values, parseFloat(inputValue.trim())]));
      setInputValue("");
    }
  };

  const handleDeleteRange = (index) => {
    // Create a new array without the range at the specified index
    const updatedRangePairs = rangePairs.filter((_, i) => i !== index);
    // Update the state with the new array
    dispatch(setRangePairs(updatedRangePairs));
  };

  const handleDeleteValues = (index) => {
    const updatedValues = [...values]; // Create a copy of the current values array
    updatedValues.splice(index, 1); // Remove the value at the specified index
    dispatch(setValues(updatedValues)); // Update the state with the new values array
  };


  return (
    <div className="masking-range-values-container">
      <div>
        <Typography fontWeight={500} fontFamily={"unset"} fontSize={22}>
          Values to mask by
        </Typography>

        {/* Range of values */}
        <Typography textAlign={"left"} fontWeight={500} fontSize={18}>
          Range Value
        </Typography>
        <div>
          <Grid container spacing={2}>
            <Grid item>
              <TextField
                size="small"
                label="Start"
                value={startValue}
                onChange={handleStartChange}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <TextField
                size="small"
                label="End"
                value={endValue}
                onChange={handleEndChange}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <Button
                size="small"
                onClick={handleAddRange}
                variant="contained"
                color="primary"
              >
                Add Range
              </Button>
            </Grid>
            <br />
          </Grid>
          <Grid marginTop={"1em"}>
            <Grid
              flexWrap={"wrap"}
              gap={"1em"}
              display={"flex"}
              flexDirection={"row"}
              width={"100%"}
              marginTop={"1em"}
            >
              {rangePairs.map((range, index) => (
                <div style={{ display: "flex" }}>
                  <Typography key={index} className="selected">
                    Range {index + 1}: {range[0]} - {range[1]}
                  </Typography>
                  <div
                    className="delete-icon-mask"
                    onClick={() => handleDeleteRange(index)}
                  >
                    <DeleteIcon
                      sx={{
                        cursor: "pointer",
                      }}
                      color="error"
                    />
                  </div>
                  <br />
                </div>
              ))}
            </Grid>
          </Grid>
        </div>
        <br />
        {/* multiple selection */}
        <Typography textAlign={"left"} fontWeight={500} fontSize={18}>
          Single Value
        </Typography>
        <div>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <TextField
                size="small"
                label="Enter Value"
                value={inputValue}
                onChange={handleInputChangeMultiple}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <Button
                size="small"
                onClick={handleAddValue}
                variant="contained"
                color="primary"
              >
                Add
              </Button>
            </Grid>
          </Grid>
          <Grid marginTop={"1em"}>
            <Grid
              flexWrap={"wrap"}
              gap={"1em"}
              display={"flex"}
              flexDirection={"row"}
              width={"100%"}
              marginTop={"1em"}
            >
              {values.map((value, index) => (
                <div style={{ display: "flex" }}>
                  <Typography key={index} className="selected">
                    Value {index + 1}: {value}
                  </Typography>
                  <div
                    className="delete-icon-mask"
                    onClick={() => handleDeleteValues(index)}
                  >
                    <DeleteIcon
                      sx={{
                        cursor: "pointer",
                      }}
                      color="error"
                    />
                  </div>
                  <br />
                </div>
              ))}
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default ValuesAndRangesComponent;
